/**
 * AlertTypeBadge — displays AlertSubType as a styled badge tag
 * with a hover popover showing the AlertType (category).
 */

import { useState, useRef } from 'react';

const AlertTypeBadge = ({ alertType, alertSubType }) => {
    const [open, setOpen] = useState(false);
    const [style, setStyle] = useState({});
    const ref = useRef(null);

    const handleEnter = () => {
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            const popoverWidth = 200;
            const spaceRight = window.innerWidth - rect.left;
            const spaceBelow = window.innerHeight - rect.bottom;

            const horizontal = spaceRight < popoverWidth + 16
                ? { right: `${window.innerWidth - rect.right}px`, left: 'auto' }
                : { left: `${rect.left}px`, right: 'auto' };

            const vertical = spaceBelow < 60
                ? { bottom: `${window.innerHeight - rect.top + 6}px`, top: 'auto' }
                : { top: `${rect.bottom + 6}px`, bottom: 'auto' };

            setStyle({ position: 'fixed', ...horizontal, ...vertical });
        }
        setOpen(true);
    };

    if (!alertSubType && !alertType) return <span>—</span>;

    return (
        <span ref={ref} onMouseEnter={handleEnter} onMouseLeave={() => setOpen(false)} style={{ position: 'relative' }}>
            <span className="na-type-tag">{alertSubType || alertType || '—'}</span>
            {open && alertType ? (
                <div className="na-type-popover" style={style}>
                    <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)' }}>Category</span>
                    <span style={{ fontSize: 'var(--font-size-sm)', fontWeight: 600, color: 'var(--color-text-heading)' }}>{alertType}</span>
                </div>
            ) : null}
        </span>
    );
};

export default AlertTypeBadge;
